import { TextField } from '@warp-ds/react';
import cn from 'classnames';
import { useExperiment } from '@/hooks/experiments';
import styles from './PersonalInfoFields.module.css';
import { PhoneNumberFieldset } from './PhoneNumberFieldset';

type PersonalInfoFieldsProps = {
    firstname: string;
    setFirstname: (value: string) => void;
    surname: string;
    setSurname: (value: string) => void;
    dateOfBirth: string;
    setDateOfBirth: (value: string) => void;
    landcode: string;
    setLandCode: (value: string) => void;
    phone: string;
    setPhone: (value: string) => void;
    getFieldError: (field: 'firstname' | 'surname' | 'dateOfBirth' | 'phone') => string | null;
    isFieldInvalid: (field: 'firstname' | 'surname' | 'dateOfBirth' | 'phone') => boolean;
};

export const PersonalInfoFields = ({
    firstname,
    setFirstname,
    surname,
    setSurname,
    dateOfBirth,
    setDateOfBirth,
    landcode,
    setLandCode,
    phone,
    setPhone,
    getFieldError,
    isFieldInvalid,
}: PersonalInfoFieldsProps) => {
    const experiment = useExperiment();
    const showUpdatedRequestPage = experiment?.['travel-fhh-tjvr-request-page-drop-off-reduction'] === 'treatment';

    return (
        <>
            <div className="flex w-full gap-8">
                <TextField
                    name="firstName"
                    label="Fornavn"
                    value={firstname}
                    className="w-full"
                    onChange={(e) => setFirstname(e.target.value)}
                    helpText={getFieldError('firstname')}
                    invalid={isFieldInvalid('firstname')}
                />
                <TextField
                    name="lastName"
                    label="Etternavn"
                    className="w-full"
                    value={surname}
                    onChange={(e) => setSurname(e.target.value)}
                    helpText={getFieldError('surname')}
                    invalid={isFieldInvalid('surname')}
                />
            </div>
            <div className="flex flex-col gap-14 w-full box-border md:max-w-[350px]">
                <TextField
                    name="dateOfBirth"
                    // @ts-expect-error TextField types don't include 'date' but it safely passes through to the underlying HTML input
                    type="date"
                    label="Fødselsdato"
                    className={cn('w-full max-w-full', styles.birthdayInput)}
                    value={dateOfBirth}
                    onChange={(e) => setDateOfBirth(e.target.value)}
                    helpText={getFieldError('dateOfBirth') || (showUpdatedRequestPage && 'Vi spør kun for å sikre at du er over 18 år.')}
                    invalid={isFieldInvalid('dateOfBirth')}
                />
                <PhoneNumberFieldset
                    landcode={landcode}
                    setLandCode={setLandCode}
                    phone={phone}
                    setPhone={setPhone}
                    getFieldError={getFieldError}
                    isFieldInvalid={isFieldInvalid}
                />
            </div>
        </>
    );
};
